var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafePayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 74,
    viewBox: "0 0 121 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.0022 60.7944H6.55333C3.48631 60.7944 1 58.2846 1 55.1886V6.60506C1 3.50907 3.48631 0.999268 6.55333 0.999268H88.0022C91.0692 0.999268 93.5556 3.50907 93.5556 6.60506V30.8968",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.0798H91.5379",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.4224H91.5379",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2139 37.2129C21.8626 35.6433 19.8819 34.6343 17.6605 34.6343C13.5696 34.6343 10.2561 37.9791 10.2561 42.1087C10.2561 46.2383 13.5696 49.5831 17.6605 49.5831C19.8819 49.5831 21.8626 48.574 23.2139 47.0044",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2134 37.2129C24.5647 35.6433 26.5454 34.6343 28.7667 34.6343C32.8577 34.6343 36.1712 37.9791 36.1712 42.1087C36.1712 46.2383 32.8577 49.5831 28.7667 49.5831C26.5454 49.5831 24.5647 48.574 23.2134 47.0044",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2132 37.2124C22.084 38.5204 21.3621 40.2208 21.3621 42.1081C21.3621 43.9954 22.084 45.6958 23.2132 47.0039",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.106 45.4577L100.392 54.7569L96.0344 50.1073M120 48.1662C120 63.4362 109.176 70.2822 104.587 72.4985L104.582 72.5012C104.099 72.7343 103.857 72.8511 103.309 72.9516C102.961 73.0152 102.182 73.0152 101.834 72.9516C101.284 72.8507 101.039 72.7334 100.553 72.4985C95.9643 70.2822 85.1411 63.4361 85.1411 48.1662V38.9486C85.1411 36.3446 85.1411 35.0416 85.616 34.047C86.0338 33.1721 86.6999 32.4613 87.5198 32.0156C88.4519 31.5088 89.6729 31.5088 92.1133 31.5088H113.028C115.469 31.5088 116.687 31.5088 117.619 32.0156C118.439 32.4613 119.108 33.1721 119.525 34.047C120 35.0406 120 36.3421 120 38.941V48.1662Z",
    stroke: "#2F1612",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePayments);
export default __webpack_public_path__ + "static/media/safe-payments.1311b5bad0c541ad5f8c45610e0ea96d.svg";
export { ForwardRef as ReactComponent };